export type ConversionEvent = "waitlist_view" | "waitlist_submit" | "waitlist_success" | "waitlist_error";

type EventDetail = { event: ConversionEvent; source: "public-site"; status?: number };

/**
 * A deliberately provider-free adapter. A future approved analytics integration
 * can listen for this event; email and other form values are never included.
 */
export function trackConversion(event: ConversionEvent, status?: number): void {
  window.dispatchEvent(new CustomEvent<EventDetail>("citethemove:conversion", {
    detail: { event, source: "public-site", ...(status ? { status } : {}) },
  }));
}
